
import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export function Home() {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const position = window.scrollY;
      setScrollPosition(position);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Calculate opacity based on scroll position
  const opacity = Math.max(0, 2 - scrollPosition / (window.innerHeight / 3));

  return (
    <div>
  <div className="second-div">
    <Container>
        <Row>
            <Col>
                <h1>Dina Stojilkovic</h1>
                <p>
                  Dina Stojilković is a concert pianist, pedagogue, and chamber musician based in Berlin, Germany. A bright representative of a new generation of pianists, she performs regularly across Europe. Stojilković has received numerous awards at national and international competitions and is also a respected teacher, with several of her students winning prestigious prizes.

                </p>
            </Col>
        </Row>
    </Container>
</div>


      <div className="first-div" style={{ 
        backgroundImage: `url('./img/IMG-20240220-WA0001.jpg')`,
        backgroundSize: 'contain',
        // backgroundPosition: 'left 30% bottom 20%',
        boxShadow: '0px -25px 20px -20px rgba(0,0,0,0.45), 0px 25px 20px -20px rgba(0,0,0,0.45)',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: 'black',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        height: '100vh',
        position: 'relative',
        display: 'flex'
      }}>
        <div className="gradient-overlay" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: `linear-gradient(rgba(0, 0, 0, ${opacity}), rgba(0, 0, 0, ${opacity}))`
        }}></div>
        <Container>
          <Row>
            <Col>
              <h1 className='main-headline'>Dina Stojilkovic</h1>
            </Col>
          </Row>
        </Container>
      </div>
     <div className="second-div" style={{ backgroundColor: '#fff'}}>
    <Container>
        <Row>
            <Col>
                </Col>
        </Row>
    </Container>
</div>
    </div>
  );
}